import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./full-fleet.scss";
import Header from "../_Common/header";
import { Button, Col, Container, Image, Nav, Row, Tab } from "react-bootstrap";
import Aos from "aos";

// Icons
import sailingIcon from "../../assets/img/home/our-fleet/icons/sailing-boat.png";
import boatIcon from "../../assets/img/home/our-fleet/icons/boat.png";
import starIcon from "../../assets/img/home/our-fleet/icons/star.png";
import lightingIcon from "../../assets/img/home/our-fleet/icons/lighting.png";
// Placeholder for Ferry Icon (reusing boat for now or generic)
import ferryIcon from "../../assets/img/home/our-fleet/icons/boat.png";

// Images (Using existing ones as placeholders where needed)


import fleetInventory from "../../json/FullFleet/fleet-inventory.json";

// Image Mapping


// Data Construction - Processed from JSON
const fleetData = Object.keys(fleetInventory).reduce((acc, category) => {
  acc[category] = fleetInventory[category].map((boat) => ({
    ...boat,
    image: boat.image ? `/${boat.image}` : boatIcon,
  }));
  return acc;
}, {});

const tabs = [
  { id: "sail_boats", name: "Sail Boats", icon: sailingIcon },
  { id: "sail_yachts", name: "Sail Yachts", icon: boatIcon },
  { id: "motor_yachts", name: "Motor Yachts", icon: starIcon },
  { id: "speed_boats", name: "Speed Boats", icon: lightingIcon },
  { id: "ferry_boats", name: "Ferry Boats", icon: ferryIcon },
];

export default function FullFleet() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [aosKey, setAosKey] = useState(0);
  const [activeTab, setActiveTab] = useState(searchParams.get("category") || "sail_boats");

  useEffect(() => {
    const categoryParam = searchParams.get("category");
    if (categoryParam && fleetData[categoryParam]) {
      setActiveTab(categoryParam);
    }
  }, [searchParams]);

  useEffect(() => {
    window.scrollTo(0, 0);
    Aos.init({ duration: 800, once: false });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      Aos.refreshHard();
    }, 100);
  }, [aosKey]);

  const handleTabClick = () => setAosKey((prev) => prev + 1);

  const handleTabSelect = (key) => {
    setActiveTab(key);
    handleTabClick();
    setSearchParams({ category: key }, { replace: true });
  };

  const handleBookNow = (boat) => {
    // Razorpay Link Construction
    const FIXED_PRICE = 2000;
    const url = `https://pages.razorpay.com/yachtmumbai?amount=${FIXED_PRICE}&yacht_name=${encodeURIComponent(boat.name)}&name=&email=&phone=`;
    window.open(url, "_blank");
  };

  const handleViewDetail = (boat) => {
    // Create slug from name (e.g., 'SM 63' -> 'sm-63')
    const slug = boat.name.toLowerCase().replace(/ /g, '-');
    navigate(`/fleet-detail/${slug}?category=${activeTab}`);
  };

  // Reset page on tab change
  const handleTabClickWrapped = () => {
    handleTabClick();
  };

  const currentTabData = fleetData[activeTab] || [];
  const currentItems = currentTabData;

  return (
    <React.Fragment>
      <Header />
      {/* OUR FLEET CONTENT */}
      <section className="our-fleet-section">
        <Container>
          <div className="our-fleet-content">
            <span
              className="premium-fleet-badge"
              data-aos="fade"
              data-aos-duration="2000"
            >
              <i className="ri-vip-crown-fill"></i> Premium Collection
            </span>
            <div data-aos="fade-up" data-aos-duration="2000">
              <h2>Discover Our Fleet</h2>
              <p>
                Choose from our exclusive collection of luxury yachts and
                speedboats for your perfect sea voyage.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* FLEET TABS */}
      <section className="fleet-nav-tab-section">
        <Container>
          <Tab.Container
            id="left-tabs-example"
            activeKey={activeTab}
            onSelect={handleTabSelect}
          >
            <div className="fleet-tabs-header text-center">
              <Nav variant="pills" className="justify-content-center">
                {tabs.map((tab) => (
                  <Nav.Item key={tab.id}>
                    <Nav.Link eventKey={tab.id} onClick={handleTabClickWrapped}>
                      {tab.name}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </div>

            <div className="fleet-tabs-content">
              <Tab.Content>
                <Tab.Pane eventKey={activeTab} key={activeTab}>
                  <div className="row g-4" data-aos="fade-up" key={aosKey}>
                    {currentItems.map((boat, index) => (
                      <div key={index} className="col-lg-4 col-md-4 col-12">
                        <div className="fleet-grid-card">
                          <div className="card-img-wrapper">
                            <Image src={boat.image} alt={boat.name} fluid />
                            {boat.badge && (
                              <span className="badge-overlay">{boat.badge}</span>
                            )}
                          </div>
                          <div className="card-content">
                            <h3>{boat.name}</h3>
                            <p className="guests">
                              <i className="ri-group-line"></i> {boat.guests} Guests
                            </p>
                            <p className="description">{boat.description}</p>

                            {/* Trip / Route Section */}
                            {boat.trips && boat.trips.length > 0 && (
                              <div className="trip-info">
                                <strong>Trip:</strong>
                                {boat.trips.length === 1 ? (
                                  <span> {boat.trips[0]}</span>
                                ) : (
                                  <ul className="trip-list mb-0">
                                    {boat.trips.map((trip, tIndex) => (
                                      <li key={tIndex}>{trip}</li>
                                    ))}
                                  </ul>
                                )}
                              </div>
                            )}

                            <div className="d-flex gap-2">
                              <Button
                                className="common-btn flex-fill"
                                onClick={() => handleViewDetail(boat)}
                              >
                                View Detail
                              </Button>
                              <Button
                                variant="outline-primary"
                                className="view-details-btn flex-fill"
                                onClick={() => handleBookNow(boat)}
                              >
                                Book Now
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </div>
          </Tab.Container>
        </Container>
      </section>


    </React.Fragment>
  );
}
